class getVayyarinfomodel {
    constructor(json) {
        this.mac = json.mac;
        this.id = json.id;
        this.anchormac = json.anchormac;
        this.rssi = json.rssi;
    }
}
export { getVayyarinfomodel}
